
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCardGrid } from '@ds/components/CardGrid'
import { RevCategoryCard } from '@ds/components/CategoryCard'
import { RevIllustration } from '@ds/components/Illustration'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconQuality } from '@ds/icons/IconQuality'
import { mapGetters } from 'vuex'

import translations from './Categories.translations'

export default {
  components: {
    RevIllustration,
    RevButtonBase,
    IconQuality,
    IconMoney,
    IconPackage,
    RevCategoryCard,
    RevCardGrid,
  },
  props: {
    categories: {
      type: Object,
      default: () => {},
    },
    hasIntro: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      breakpoint: 'breakpoint',
    }),
    translations: () => translations,
    estimations() {
      return {
        smartphone: this.$t(translations.smartphonePrice),
        macbook: this.$t(translations.macbookPrice),
        tablet: this.$t(translations.tabletPrice),
        // eslint-disable-next-line camelcase
        gaming_console: this.$t(translations.consolePrice),
        audio: this.$t(translations.audioPrice),
      }
    },
    categoriesFormatted() {
      const categories = this.categories.options

      return categories.map((category) => {
        return {
          description: this.estimations[category.value],
          image: {
            alt: category.label,
            src: category.icon.light,
          },
          link: '',
          title: category.label,
          value: category.value,
        }
      })
    },
    options() {
      return (
        (this.categories.options &&
          this.categories.options.map(({ value, ...rest }) => {
            return {
              ...rest,
              value,
              priceEstimation: this.estimations[value],
            }
          })) ||
        []
      )
    },
    title() {
      return this.categories.title
    },
  },
  methods: {
    handleClick(value) {
      this.$emit('next-step', { category: value })
    },
  },
}
